import { render } from "./ModulesListEducation.vue?vue&type=template&id=917b5e9a&scoped=true"
import script from "./ModulesListEducation.vue?vue&type=script&lang=js"
export * from "./ModulesListEducation.vue?vue&type=script&lang=js"

import "./ModulesListEducation.vue?vue&type=style&index=0&id=917b5e9a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-917b5e9a"]])

export default __exports__